import cn from 'classnames';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

import { Select } from '@/shared/ui';

import { AdditionalInfoFormPayload } from '../../config/types';
import { useGetSpecializationOptions } from '../../hooks/useGetSpecializationOptions';
import styles from '../../Steps.module.scss';

type OwnerSpecializationProps = {
  control: Control<AdditionalInfoFormPayload>;
  className?: string;
  testID?: string;
};

export const OwnerSpecializationStep: FC<OwnerSpecializationProps> = (
  props,
) => {
  const { control, className, testID } = props;

  const specializationOptions = useGetSpecializationOptions();

  return (
    <div
      className={cn(styles.container, className)}
      data-testid={testID}
      data-component="owner-specialization-step"
    >
      <Controller
        control={control}
        name="OwnerSpecialization"
        render={({
          field: { ref, value, name, onBlur, onChange },
          fieldState: { error },
        }) => (
          <Select
            options={specializationOptions}
            isRequired
            ref={ref}
            value={value}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            error={error?.message}
          />
        )}
      />
    </div>
  );
};
